import MarkdownTextOptions from './MarkdownTextOptions';

export default MarkdownTextOptions;
